module.exports = __webpack_public_path__ + "img/ntk_nav_add_w.528b7f14.svg";